export default __webpack_public_path__ + "static/media/pic4.6ba7bc8f.jpg";